import {combineReducers} from '@reduxjs/toolkit';
import areaCoverage from './area-coverage.js';
import compare from './compare.js';
import enhanceMode from './enhanceMode.js';
import featureCollections from './featureCollections.ts';
import focusedItems from './focused-items.js';
import filters from './item-filters.js';
import itemTypes from './item-types.js';
import map from './map.js';
import quickFocusedItems from './quick-focused-items.js';
import quotaManagement from './quotaManagement.ts';
import results from './results.js';
import searchFilters from './search-filters.js';
import search from './search.js';
import settings from './settings.js';
import sidebar from './sidebar.js';
import ui from './ui.js';

const combinedReducers = combineReducers({
  areaCoverage,
  compare,
  enhanceMode,
  featureCollections,
  filters,
  focusedItems,
  itemTypes,
  map,
  quickFocusedItems,
  quotaManagement,
  results,
  search,
  searchFilters,
  sidebar,
  ui,
  settings,
});

export default combinedReducers;
